var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotProtected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.982 0.556188L11.4405 1.16369C9.1455 3.74069 5.9595 4.95719 2.1585 5.42069L1.5 5.50019V6.16469C1.5 10.0347 2.319 13.7892 4.014 16.8672C5.709 19.9452 8.31 22.3467 11.7855 23.3832L12.009 23.4507L12.231 23.3742C18.948 21.2037 22.5 14.1327 22.5 6.16469V5.56769L21.9165 5.42969C18.219 4.57769 14.8095 3.54269 12.5445 1.15019L11.982 0.554688V0.556188ZM12.018 2.55119C14.4465 4.81919 17.6355 5.91119 20.9385 6.70019C20.781 13.8717 17.643 19.8537 11.994 21.8232C9.0525 20.8707 6.831 18.8682 5.3295 16.1427C3.8655 13.4877 3.1395 10.1697 3.0615 6.71969C6.534 6.19319 9.6345 4.94969 12.0165 2.55119H12.018Z",
    fill: "#F54336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L9 15",
    stroke: "#F54336",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9L15 15",
    stroke: "#F54336",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotProtected);
export default __webpack_public_path__ + "static/media/not-protected.b8ba574135687fb289e8a083014688fd.svg";
export { ForwardRef as ReactComponent };